import { Grid } from '@mui/material';
import styled from 'styled-components';
import { color } from '../../theme/Color';

interface MainContainerProps {
  mode: any;
}

interface InnerContainerProps {
  mode: any;
  isDesktop: any;
  isDTVValueCreation: any;
  ipadMini: any;
}
export const MainContainer = styled(Grid).withConfig({
  shouldForwardProp: (prop) => !['mode'].includes(prop),
})<MainContainerProps>`
  display: flex;
  border-radius: 8px;
  position: relative;
  border: ${({ mode }) =>
    mode === 'light' ? `1px solid ${color._D7E5F8}` : ' '};
  background: ${({ mode }) =>
    mode === 'light'
      ? `${color._FBFCFE} !important`
      : `${color._1d1d1d} !important`};
  margin-top: 10px;
  & .kpiDef {
    margin-top: 8px;
  }
  & .desktopDrawerIcon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`;
export const InnerContainer = styled(Grid).withConfig({
  shouldForwardProp: (prop) =>
    !['mode', 'isDesktop', 'isDTVValueCreation', 'ipadMini'].includes(prop),
})<InnerContainerProps>`
  border-radius: 8px;
  background: ${({ mode }) =>
    mode === 'light'
      ? `${color._FBFCFE} !important`
      : `${color._1d1d1d} !important`};
  justify-content: space-around;
  align-items: center;
  padding: ${({ isDTVValueCreation, ipadMini }) =>
    isDTVValueCreation && ipadMini ? '14px' : '20px'};
  color: white;

  @media (max-width: 962px) {
    justify-content: space-around;
    text-align: center;
  }
  @media (max-width: 600px) {
    text-align: center;
  }
  & .verticalBarContainer {
    border-width: 1px;
    background: ${({ mode }) =>
      mode === 'light' ? color._B2CAEA : color._666666};
    height: 90px;
    margin-right: ${({ isDesktop }) => (isDesktop ? '25px' : ' ')};

    @media (max-width: 600px) {
      &:nth-of-type(even) {
        display: none;
      }
    }
  }

  & .header-items {
    @media (min-device-width: 768px) and (max-device-width: 820px) {
      margin: 16px;
      max-width: 154px !important;
    }
  }
`;
